import { useSite } from "@/context/SiteContext";

export default function LangToggle({ className = "", testid = "lang-toggle" }) {
  const { lang, setLang } = useSite();
  return (
    <div className={`inline-flex items-center p-1 rounded-full bg-white border border-[rgba(20,40,26,.12)] text-xs font-bold ${className}`} role="group" aria-label="Language" data-testid={testid}>
      {[["en", "EN"], ["hi", "हिं"]].map(([k, l]) => (
        <button key={k} onClick={() => setLang(k)} aria-pressed={lang === k} data-testid={`${testid}-${k}`}
          className={`px-2.5 py-1.5 rounded-full transition-colors ${lang === k ? "bg-[var(--leaf)] text-white" : "text-[var(--ink-soft)] hover:text-[var(--ink)]"}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
